<template>
    <div class="flex justify-center pb-10 text-center align-center items-center h-200">
        <div>
            <img src="/assets/errorimg.svg" width="500" alt="404" />
            <h1 class="pt-3 text-[40px] font-semibold">Opps!!!</h1>
            <h4 class="my-8 text-xl font-medium">
                Esta página que você procura não foi encontrada.
            </h4>
            <NuxtLink to="/" class="bg-[#0400A1] text-white rounded-full px-3 py-2 text-base font-normal truncate" aria-current="page">
                Voltar à página inicial
            </NuxtLink>
        </div>
    </div>
</template>
